<template>
    <div>
        <v-list
            class="elevation-0 pa-0 custom__list"
            :class="{ 'overflow-hidden': height === '264', 'overflow-auto': height !== '264' }"
            :height="height"
            nav
            dense
        >
            <v-list-item-group
                v-model="items"
                class="elevation-0"
                multiple
            >
                <div
                    v-for="category in allItems"
                    :key="category.id"
                >
                    <span>{{ category.name }}</span>

                    <v-list-item
                        v-for="item in category.items"
                        :key="item.id"
                        :value="item.id"
                        dense
                        link
                        :color="item.color"
                        class="ps-1 text-body-2 rounded-lg mb-1"
                        @click="emit('update-items', item)"
                    >
                        <v-icon size="14" :color="item.color" class="mr-2">far fa-circle</v-icon>

                        <div class="mr-2 white--text">{{ item.count }}</div>

                        <div class="white--text">{{ item.name }}</div>
                    </v-list-item>
                </div>
            </v-list-item-group>
        </v-list>

        <v-btn
            v-if="showAllCountsExtension"
            depressed
            block
            color="transparent"
            class="text-none d-flex mt-2"
            @click="showAllCounts"
        >
            <span class="primary--text">
                {{ $t('kds.drawer.view_all_counts') }}
            </span>
        </v-btn>
    </div>
</template>

<script setup>
import { ref, computed, defineProps, defineEmits } from 'vue';

const emit = defineEmits(['show-all-counts', 'update-items']);

const props = defineProps({
    height: {
        type: [String, Number],
        default: 264,
    },
    selectedItems: {
        type: Array,
        default: () => [],
    },
    allItems: {
        type: Array,
        default: () => [],
    },
    limited: {
        type: Boolean,
        default: true,
    }
});

const items = ref([...props.selectedItems.map((item) => item.id)]);

const showAllCountsExtension = computed(() => {
    return props.allItems.length >= 2 || (props.allItems.length && props.allItems[0].items.length >= 6)
});

const showAllCounts = () => {
    emit('show-all-counts');
};
</script>

<style lang="scss" scoped>
::v-deep(.v-list) {
    ::-webkit-scrollbar {
        display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
}

::v-deep(.v-list::-webkit-scrollbar) {
    width: 0px !important;
}
</style>
